var _filter, _clipPath, _clipPath2, _clipPath3, _use, _use2, _use3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWord(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "alpha",
    filterUnits: "objectBoundingBox",
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    in: "SourceGraphic",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 48,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.2,
      stroke: "none"
    }
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface5",
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 0 5.21875 L 0 5.71875 L 28 0.5 L 28 0 Z M 0 5.21875 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 48,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.101961,
      stroke: "none"
    }
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface8",
    clipPath: "url(#clip2)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 0 42.78125 L 28 48 L 28 47.5 L 0 42.28125 Z M 0 42.78125 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear0",
    gradientUnits: "userSpaceOnUse",
    x1: 9.5,
    y1: 7.5,
    x2: 23.353638,
    y2: 21.353638,
    gradientTransform: "matrix(2,0,0,2,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(0%,0%,0%)",
      stopOpacity: 0.101961
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(0%,0%,0%)",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 48,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.0509804,
      stroke: "none"
    }
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear1",
    gradientUnits: "userSpaceOnUse",
    x1: -337.186005,
    y1: 438.870789,
    x2: -336.95639,
    y2: 438.870789,
    gradientTransform: "matrix(121.951218,0,0,121.951218,41120.242188,-53496.828125)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(100%,100%,100%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(0%,0%,0%)",
      stopOpacity: 1
    }
  })), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface11",
    clipPath: "url(#clip3)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear1)"
    },
    d: "M 28 0 L 0 5.21875 L 0 42.78125 L 28 48 Z M 28 0 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear2",
    gradientUnits: "userSpaceOnUse",
    x1: -1.56345,
    y1: 5.961533,
    x2: 25.045399,
    y2: 18.369442,
    gradientTransform: "matrix(2,0,0,2,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(100%,100%,100%)",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(100%,100%,100%)",
      stopOpacity: 0
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 24 7 L 47 7 L 47 41 L 24 41 Z M 24 7 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0.392157%,36.078431%,67.058824%)",
      fillOpacity: 1
    },
    d: "M 47 42 L 27 42 C 26.445312 42 26 41.554688 26 41 C 26 40.445312 26.445312 40 27 40 L 46 40 L 46 8 L 27 8 C 26.445312 8 26 7.554688 26 7 C 26 6.445312 26.445312 6 27 6 L 47 6 C 47.554688 6 48 6.445312 48 7 L 48 41 C 48 41.554688 47.554688 42 47 42 Z M 47 42 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0.392157%,36.078431%,67.058824%)",
      fillOpacity: 1
    },
    d: "M 28 0 L 0 5.21875 L 0 42.78125 L 28 48 Z M 28 0 "
  }), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface5",
    mask: "url(#mask0)"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface8",
    mask: "url(#mask1)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0.392157%,36.078431%,67.058824%)",
      fillOpacity: 1
    },
    d: "M 27 11 L 43 11 L 43 13 L 27 13 Z M 27 11 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0.392157%,36.078431%,67.058824%)",
      fillOpacity: 1
    },
    d: "M 27 17 L 43 17 L 43 19 L 27 19 Z M 27 17 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0.392157%,36.078431%,67.058824%)",
      fillOpacity: 1
    },
    d: "M 27 23 L 43 23 L 43 25 L 27 25 Z M 27 23 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0.392157%,36.078431%,67.058824%)",
      fillOpacity: 1
    },
    d: "M 27 29 L 43 29 L 43 31 L 27 31 Z M 27 29 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0.392157%,36.078431%,67.058824%)",
      fillOpacity: 1
    },
    d: "M 27 35 L 43 35 L 43 37 L 27 37 Z M 27 35 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear0)"
    },
    d: "M 47 42 C 47.554688 42 48 41.554688 48 41 L 48 26 L 28 6 L 28 42 Z M 47 42 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 15.875 33.0625 L 18 33.214844 L 22.425781 16.46875 L 19.261719 16.695312 L 16.949219 25.367188 C 16.949219 25.367188 15.773438 21.085938 14.65625 17.023438 L 11.277344 17.265625 L 9.050781 25.367188 L 6.972656 17.574219 L 3.921875 17.792969 L 7.808594 32.484375 L 10.238281 32.660156 L 13 23 C 13 23 14.585938 28.546875 15.875 33.0625 Z M 15.875 33.0625 "
  }), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface11",
    mask: "url(#mask2)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear2)"
    },
    d: "M 47 6 L 28 6 L 28 0 L 0 5.21875 L 0 42.78125 L 28 48 L 28 42 L 47 42 C 47.554688 42 48 41.554688 48 41 L 48 7 C 48 6.445312 47.554688 6 47 6 Z M 47 6 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWord);
export default __webpack_public_path__ + "static/media/word.a306ebe0d244c09a23d2fc1a8ca1ecdd.svg";
export { ForwardRef as ReactComponent };